import { render, staticRenderFns } from "./fastPhrase.vue?vue&type=template&id=599abdf6"
import script from "./fastPhrase.vue?vue&type=script&lang=js"
export * from "./fastPhrase.vue?vue&type=script&lang=js"
import style0 from "./fastPhrase.vue?vue&type=style&index=0&id=599abdf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports